import { useEffect } from 'react'

/**
 * Marks <body> while a client-portal screen is mounted so the page itself is
 * paper rather than the staff app's dark canvas. Paired with the
 * `body.portalPage` rule in pages/portal/portal-theme.css.
 *
 * Also points the page at the portal's own manifest. The app and the portal
 * share one origin and one service worker, but an athlete who adds the
 * portal to their Home Screen should open on the portal, not the agent app.
 * Safari reads the manifest at install time, so swapping the link while any
 * portal page (login included) is open is enough.
 */
export function usePortalTheme() {
  useEffect(() => {
    document.body.classList.add('portalPage')
    const link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]')
    const previous = link?.getAttribute('href')
    if (link) link.setAttribute('href', '/portal.webmanifest')
    return () => {
      document.body.classList.remove('portalPage')
      if (link && previous) link.setAttribute('href', previous)
    }
  }, [])
}
